import { BaseRoutes } from './base.routes.constants';

export class MedicoRoutes extends BaseRoutes {
  constructor(route: string) {
    super(route);
  }
}
